import React, { useState } from 'react';
import { Box, Typography, Paper, Card, CardContent, IconButton, Tooltip, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { TrendingUp as PromoteIcon, Delete as DeleteIcon } from '@mui/icons-material';
import QuestionReactions from '../../../../components/QuestionReactions';

/**
 * Suggestions Tab - Community suggestions with reactions
 */
const SuggestionsTab = ({ suggestions, onPromote, onReject, user, questions }) => {
  const [promoteDialog, setPromoteDialog] = useState({ open: false, suggestion: null });

  const handlePromoteClick = (suggestion) => {
    setPromoteDialog({ open: false, suggestion });
    onPromote(suggestion, questions);
  };

  return (
    <Box>
      {/* Header */}
      <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3, bgcolor: 'info.light' }}>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          💡 Community Suggestions ({suggestions.length})
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Questions suggested by family members • Promote to add to queue
        </Typography>
      </Paper>

      {/* Suggestions List */}
      {suggestions.length === 0 ? (
        <Paper elevation={1} sx={{ p: 4, textAlign: 'center', borderRadius: 3 }}>
          <Typography variant="body1" color="text.secondary">
            No suggestions yet
          </Typography>
        </Paper>
      ) : (
        suggestions.map((suggestion) => (
          <Card key={suggestion.id} sx={{ mb: 2, borderRadius: 3 }}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Box flex={1}>
                  <Typography variant="h6" gutterBottom>
                    {suggestion.questionText}
                  </Typography>

                  {/* Reactions */}
                  {suggestion.reactions && (
                    <Box mb={2}>
                      <QuestionReactions
                        question={suggestion}
                        user={null}
                        adminMode={true}
                      />
                    </Box>
                  )}

                  {/* Metadata */}
                  <Box display="flex" gap={2} flexWrap="wrap">
                    {suggestion.suggestedByName && (
                      <Typography variant="caption" color="text.secondary">
                        💬 Suggested by: {suggestion.suggestedByName}
                      </Typography>
                    )}
                    {suggestion.createdAt && (
                      <Typography variant="caption" color="text.secondary">
                        📅 {new Date(suggestion.createdAt.toDate()).toLocaleDateString()}
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Actions */}
                <Box display="flex" gap={1}>
                  <Tooltip title="Add to Queue">
                    <IconButton
                      color="success"
                      onClick={() => handlePromoteClick(suggestion)}
                    >
                      <PromoteIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete">
                    <IconButton
                      color="error"
                      onClick={() => onReject(suggestion.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))
      )}
    </Box>
  );
};

export default SuggestionsTab;
